import Entity from "lib/models/Entity";
import { computed } from "mobx";

interface CorrectionSource {
  before: string;
  after: string;
  arrayIdx: number;
}

export default class Correction extends Entity<CorrectionSource> {
  @computed
  get before(): string {
    return this.source.before;
  }

  @computed
  get after(): string {
    return this.source.after;
  }

  @computed
  get arrayIdx(): number {
    return this.source.arrayIdx;
  }
}

export type { CorrectionSource };
